import { render, staticRenderFns } from "./kelengkapanPelamar.vue?vue&type=template&id=1d5e726c"
import script from "./kelengkapanPelamar.vue?vue&type=script&lang=js"
export * from "./kelengkapanPelamar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports